import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import * as response from "autoprefixer";

// Use environment variable for the API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddSalesOrder() {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null); // Selected location
  const [orderItems, setOrderferItems] = useState([{ product_id: "", qty: 0, price: 0}]);
  const [products, setProducts] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null); // Store selected customer
  const [selectedCustomerName, setSelectedCustomerName] = useState(null); // Stores customer name
  const [description, setDescription] = useState(""); // Add description state
  // const [productsWithPrices, setproductsWithPrice] = useState([]);
  const [CollecetedLocation, setSelectCollectedLocation] = useState(null); // Selected location
  

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token missing. Please log in.");
        return;
      }

      try {
        const response = await axios.get(
          `${API_BASE_URL}/users/specific`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const userData = response.data;
        setCurrentUser(userData);

        // Fetch locations and products based on role
        if (userData.role === "Main Admin") {
          fetchAllLocations();
          fetchAllProducts();
        } else if (userData.role === "Company Admin" || userData.role === "Farm User" || userData.role === "Outlet User") {
          fetchFilteredLocations(userData);
          fetchFilteredProducts(userData);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Failed to fetch user data.");
      }
    };

    const fetchAllLocations = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/locations`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setLocations(response.data.locations);
    };

    const fetchAllProducts = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/products`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setProducts(response.data.products);
    };

    const fetchFilteredLocations = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/products/filtered-locations`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setLocations(response.data.locations);
    };

    // console.log("fetchFilteredLocations:", locations);

    const fetchFilteredProducts = async (userData) => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/products/filtered-products?organization=${userData.organization._id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setProducts(response.data.products);
    };

    const fetchCustomers = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/customers/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setCustomers(response.data.customers);
    }
    const getCurrentDate = () => {
      const now = new Date();
      return now.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    };
    setCurrentDate(getCurrentDate());

    fetchCurrentUser();
    fetchCustomers();
    
  }, []);

  useEffect(() => {
    if (selectedLocation) {
      orderItems.forEach((item, index) => {
        if (item.product_id) {
          // Fetch new prices based on the new location
          fetchProductsWithPrices(item.product_id, selectedLocation, index);
        }
      });
    }
  }, [selectedLocation]);

  const fetchProductsWithPrices = async (product_id, selectedLocation, index) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${API_BASE_URL}/orders/product-price/${product_id}/${selectedLocation}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // console.log("Product price data:", response.data);

      if (response.data && !isNaN(parseFloat(response.data.product_price?.$numberDecimal))) {
        const updatedItems = [...orderItems];
        const unitPrice = parseFloat(response.data.product_price.$numberDecimal);

        const currentQty = parseFloat(updatedItems[index].qty);
        const isQtyZero = isNaN(currentQty) || currentQty <= 0;

        updatedItems[index].unit_price = unitPrice;
        updatedItems[index].price = isQtyZero
            ? unitPrice                         // ✅ Show unit price when qty is 0
            : +(currentQty * unitPrice).toFixed(2);

        updatedItems[index].name = response.data.product_name;
        updatedItems[index].unit = response.data.product_id?.unit?.unit_name || "N/A";

        setOrderferItems(updatedItems);
      } else {
        toast.error("Failed to fetch a valid product price.");
        const updatedItems = [...orderItems];
        updatedItems[index].price = 0; // Fallback to 0 if invalid data is fetched
        setOrderferItems(updatedItems);
      }
    } catch (error) {
      console.error("Error fetching product price:", error);
      toast.error("Failed to fetch product price.");
    }
  };

  const handleAddOrderItem = () => {
    setOrderferItems([
        ...orderItems,
        {
          product_id: "",
          qty: 0,
          price: 0,
          unit_price: 0,
          unit: "N/A",
        },
      ]);
    };

    const handleRemoveOrderItem = (index) => {
      setOrderferItems(orderItems.filter((_, i) => i !== index));
    };

    const handleOrderItemChange = (index, field, value) => {
      const updatedItems = [...orderItems];

      if (field === "product_id") {
          if (!selectedLocation) {
              toast.error("Please select a location first.");
              return;
          }

          updatedItems[index][field] = value;
          fetchProductsWithPrices(value, selectedLocation, index);

      } else if (field === "qty") {
        const product = products.find(p => p._id === updatedItems[index].product_id);
        if (!product) return;
    
        const isPartialAllowed = Boolean(product.partial_qty_allocation);
        const input = value.trim();
    
        if (input === "") {
            updatedItems[index].qty = 0;
            updatedItems[index].price = 0;
            setOrderferItems(updatedItems);
            return;
        }
    
        let newQty = parseFloat(input);
        if (isNaN(newQty)) newQty = 0;
    
        if (newQty <= 0) {
            updatedItems[index].qty = 0;
            updatedItems[index].price = updatedItems[index].unit_price || 0; // ✅ Show unit price
            toast.error("Quantity must be greater than zero.");
            setOrderferItems(updatedItems);
            return;
        }
      
    
        const unitPrice = updatedItems[index].unit_price || 0;
        updatedItems[index].qty = newQty;
        updatedItems[index].price = +(newQty * unitPrice).toFixed(2);
      } else {
          updatedItems[index][field] = value;
      }

      setOrderferItems(updatedItems);
  };

  

  const calculateTotal = () => {
    return orderItems.reduce((total, item) => total + item.price , 0);
  };

  const handleSubmit = async () => {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("Authentication token is missing. Please log in again.");
            return;
        }

        if (!selectedLocation) {
            toast.error("Please select a location before submitting.");
            return;
        }

        if (!selectedCustomer) {
            toast.error("Please select a customer before submitting.");
            return;
        }

        if (orderItems.length === 0 || orderItems.some(item => !item.product_id || item.qty === 0)) {
            toast.error("Please add at least one product with a valid quantity before submitting.");
            return;
        }

        // Validation for whole numbers
        let hasError = false;

        for (const item of orderItems) {
            const product = products.find((prod) => prod._id === item.product_id);
            if (product) {
                const isPartialQuantityAllowed = Boolean(product.partial_qty_allocation); // Ensure it's a boolean
                const quantity = parseFloat(item.qty); // Convert qty to a float

                if (!isPartialQuantityAllowed && !Number.isInteger(quantity)) {
                    toast.error(`Quantity for ${product.product_name} must be a whole number.`);
                    hasError = true;
                }
            }
        }

        if (hasError) return; // Stop form submission if any errors exist
        toast.dismiss(); // Clears any lingering errors when corrected

        const orderData = {
            customer_id: selectedCustomer,
            organization_id: currentUser.organization._id,
            location_id: selectedLocation,
            pickup_location_id: CollecetedLocation,
            order_request_date: currentDate,
            orderRequestItems: orderItems.map(item => ({
                product_id: item.product_id,
                quantity: item.qty,
                remaining_qty: item.qty,
                unit_price: item.unit_price,
                total_price: item.qty * item.unit_price,
            })),
            totalOrderPrice: calculateTotal(),
            status: 'Pending',
            types: `Manually - ${currentUser.username || "Loading..."}`,
            description: description || "No description provided",
        };

        let orderResponse;
        try {
            orderResponse = await axios.post(
                `${API_BASE_URL}/orders/add-mannualy-order-request`,
                orderData,
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            toast.success(`Order successfully added!`);

            if (orderResponse.data) {
                toast.success(
                    `Order Request Confirmed! Order ID: ${orderResponse.data.orderRequest.orderRequestCode || "N/A"}`
                );
            }
        } catch (orderError) {
            console.error('Order Creation Failed: ', orderError);
            toast.error('Failed to create order request. Please try again.');
            return;
        }

        try {
            const customerResponse = await axios.get(
                `${API_BASE_URL}/customers/get-by-code/${selectedCustomer}`
            );

            const customer = customerResponse.data.customer;
            const customerWhatsApp = customer.cus_mobileno.startsWith("+94")
                ? customer.cus_mobileno
                : "+94" + customer.cus_mobileno.replace(/^0/, "");

            const fromLocation =
                locations.find((loc) => loc._id === selectedLocation)?.location_name || "N/A";

            const pickupLocation =
                locations.find((loc) => loc._id === CollecetedLocation)?.location_name || "N/A";

            if (customer.whatsapp_allowed === true) {
                await axios.post(`${API_BASE_URL}/sendwhatsapp/sendwhatsapp`, {
                    messageType: "newOrderTemplate",
                    phoneNumber: customerWhatsApp,
                    customerName: customer.customer_name,
                    orderRequestCode: response.data.orderRequest.orderRequestCode,
                    description: description || "",
                    messages: orderItems.map(item => ({
                        product_name: item.name || "N/A",
                        quantity: item.qty || 0,
                        unit: item.unit || "N/A",
                    })),
                    customerCode: customer.customer_code,
                    fromLocation,
                    pickupLocation,
                });
            }

            await axios.post(`${API_BASE_URL}/sendwhatsapp/sendwhatsapp`, {
                messageType: "OrderRequestSuccess",
                phoneNumber: customerWhatsApp,
                customerName: customer.customer_name,
                orderRequestCode: response.data.orderRequest.orderRequestCode,
                messages: orderItems.map(item => ({
                    product_name: item.name || "N/A",
                    quantity: item.qty || 0,
                    unit: item.unit || "N/A",
                })),
                description: description || "",
                fromLocation,
                pickupLocation,
            });
        } catch (whatsappError) {
            console.error("WhatsApp Notification Failed.", whatsappError);
        }
    }catch (error) {
        console.error("Unexpected error in submit:", error);
        toast.error('An unexpected error occurred. Please try again.');
    }
};

  const ProductOption = ({ data, innerRef, innerProps, isFocused, isSelected, index }) => {
    const currentCategory = data.category;
  
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`flex items-center p-2 ${isFocused ? "bg-gray-200" : ""} ${isSelected ? "bg-blue-500 text-white" : ""}`}
      >
        {data.product_image && (
          <img
            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${data.product_image}`}
            alt={data.product_name}
            className="w-10 h-10 object-cover mr-2"
          />
        )}
        <span>{data.product_name}</span>
  
        {/* Add a divider before a new category */}
        {index !== 0 && currentCategory !== data.category && (
          <div className="border-t my-2"></div>
        )}
      </div>
    );
  };
  
  const customProductSelect = (productOptions, index) => {
    // If no location is selected, show an empty list
    const filteredOptions = selectedLocation
      ? productOptions.filter(
          (product) =>
            !orderItems.some((item, i) => i !== index && item.product_id === product._id)
        )
      : [];

    return (
      <Select
        options={filteredOptions}
        getOptionLabel={(e) => e.product_name}
        getOptionValue={(e) => e._id}
        components={{
          Option: (props) => <ProductOption {...props} index={index} />,
        }}
        onChange={(selectedOption) => {
          handleOrderItemChange(index, "product_id", selectedOption?._id);
          handleOrderItemChange(index, "unit", selectedOption?.product_id?.unit?.unit_name || "N/A");
          if (selectedOption?._id) {
            fetchProductsWithPrices(selectedOption._id, selectedLocation, index);
          }
        }}
        placeholder={selectedLocation ? "Search and select product" : "Select the product price location first"}
        className="w-full"
        value={filteredOptions.find((option) => option._id === orderItems[index].product_id)}
      />
    );
  };    

  const customCustomerIDSelect = (customerOptions, selectedCustomer, setSelectedCustomer, setSelectedCustomerName) => {
    return (
      <Select
        options={customerOptions}
        getOptionLabel={(e) => e.customer_code} // Show customer ID in dropdown
        getOptionValue={(e) => e._id} // Use _id as value
        isSearchable={true} // Enable search functionality
        placeholder="Search by Customer ID"
        className="w-full"
        value={customerOptions.find((option) => option._id === selectedCustomer) || null}
        onChange={(selectedOption) => {
          setSelectedCustomer(selectedOption?._id); // Set selected customer ID
          setSelectedCustomerName(selectedOption?.customer_name); // Auto-fill the customer name
        }}
      />
    );
  };
  
  const customCustomerNameSelect = (customerOptions, selectedCustomerName, setSelectedCustomerName, setSelectedCustomer) => {
    return (
      <Select
        options={customerOptions}
        getOptionLabel={(e) => e.customer_name} // Show customer name in dropdown
        getOptionValue={(e) => e._id} // Use _id as value
        isSearchable={true} // Enable search functionality
        placeholder="Search by Customer Name"
        className="w-full"
        value={customerOptions.find((option) => option.customer_name === selectedCustomerName) || null}
        onChange={(selectedOption) => {
          setSelectedCustomer(selectedOption?._id); // Auto-fill customer ID
          setSelectedCustomerName(selectedOption?.customer_name); // Set selected customer name
        }}
      />
    );
  }

  const customLocationSelect = (locationOptions, selectedLocation, setSelectedLocation) => {
    return (
      <Select
        options={locationOptions.map((location) => ({
          label: `${location.location_name}`, // Display code + name
          value: location._id, // Use _id as the value
        }))}
        placeholder="Select a location"
        className="w-full"
        value={locationOptions
          .map((location) => ({ label: `${location.location_name}`, value: location._id }))
          .find((option) => option.value === selectedLocation) || null}
        onChange={(selectedOption) => {
          setSelectedLocation(selectedOption?.value);
        }}
      />
    );
  };

  const customCollecetedLocationSelect = (locationOptions, CollecetedLocation, setSelectCollectedLocation) => {
    return (
      <Select
        options={locationOptions.map((location) => ({
          label: `${location.location_name}`, // Display code + name
          value: location._id, // Use _id as the value
        }))}
        placeholder="Select a location"
        className="w-full"
        value={locationOptions
          .map((location) => ({ label: `${location.location_name}`, value: location._id }))
          .find((option) => option.value === CollecetedLocation) || null}
        onChange={(selectedOption) => {
          setSelectCollectedLocation(selectedOption?.value);
        }}
      />
    );
  };

  return (
    <div className="container mx-auto p-6 ">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <h2 className="text-2xl font-bold text-green-700 mb-6">Add Order Request</h2>
        <div className="grid grid-cols-4 gap-8">
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Date</label>
            <input
               type="text"
               className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
               placeholder="Enter customer ID"
               readOnly
               value={currentDate}
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Customer ID</label>
            {customCustomerIDSelect(customers, selectedCustomer, setSelectedCustomer, setSelectedCustomerName)}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Customer Name</label>
            {customCustomerNameSelect(customers, selectedCustomerName, setSelectedCustomerName, setSelectedCustomer)}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Product Price location</label>
            {customLocationSelect(locations, selectedLocation, setSelectedLocation)}
          </div>
          </div>
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-700 mb-4">Order Items</h3>

          {/* Column Headers */}
          <div className="grid grid-cols-2 gap-8 mb-1 block text-gray-700 ">
            <div>Product</div>
            <div className="grid grid-cols-4 gap-8 mb-2 block text-gray-700">
              <div>Quantity</div>
              <div className="flex items-center">Unit</div>
              <div>
                Price
              </div>
              <div>Action</div>
            </div>  
          </div>
          {/* Transfer Items Rows */}
          {orderItems.map((item, index) => (
            <div key={index} className="grid grid-cols-2 gap-8 mb-4">
              {/* Product */}
              <div className="w-full">
                {customProductSelect(products, index)}
              </div>
              <div className="grid grid-cols-4 gap-8 mb-4">
                {/* Quantity */}
                <div className="flex items-center">
                  <input
                    type="number"
                    placeholder="Qty"
                    className="p-3 border rounded-lg w-full"
                    value={item.qty}
                    step={products.find(p => p._id === item.product_id)?.partial_qty_allocation ? 0.25 : 1}
                    min="0"
                    onChange={(e) => handleOrderItemChange(index, "qty", e.target.value)}
                  />
                  {/* <span className="ml-2 text-gray-600">{orderItems[index].unit || "N/A"}</span> */}
                </div >
                <div className="ml-2 text-gray-600 flex=">
                  {orderItems[index].unit || "N/A"}
                </div>
                <div className="flex items-center">
                  <input
                  type="text"
                  className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                  value={(orderItems[index].price ?? 0).toFixed(2)} // Default to 0 if price is undefined
                  readOnly
                />
                </div>

                {/* Action (Remove Button) */}
                <div className="w-full flex items-center">
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded-lg"
                    onClick={() => handleRemoveOrderItem(index)}
                  > 
                    Remove
                  </button>
                </div>
              </div> 
            </div>
          ))}

          {/* Add Item Button */}
          <button
            className="bg-green-700 text-white px-4 py-2 rounded-lg"
            onClick={handleAddOrderItem}
            >
              Add Item
          </button>
        </div>
        <div className="mb-1">
          <div className="grid grid-cols-2 gap-8"> 
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Pickup Location</label>
            {customCollecetedLocationSelect(locations, CollecetedLocation, setSelectCollectedLocation)}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Type</label>
            <input
               type="text"
               className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
               placeholder="Type"
               readOnly
               value={`Manually - ${currentUser.username || "Loading..."}`} 
            />
          </div>
          </div>
        </div>
        <div className="mb-4">
            <label className="block text-gray-700 mb-2">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter description here..."
                rows={4}
              />
        </div>
        <div className="flex justify-between items-center mt-4">
        {/* Total Label (Left Side) */}
        <div className="text-left">
          <label className="block text-gray-700 text-2xl font-bold">Total: Rs. {calculateTotal().toFixed(2)}</label>
        </div>

        {/* Submit Button (Right Side) */}
        <div className="text-right">
          <button
            onClick={handleSubmit}
            className="bg-green-700 text-white py-3 px-6 rounded-lg hover:bg-green-600"
          >
            Submit Order Request
          </button>
        </div>
      </div>
      </div>
    </div>
  );
}

export default AddSalesOrder;